import { Featherico, IconChevronDown, IconChevronLeft, IconChevronRight, IconChevronUp } from 'featherico';
import { ComponentType } from 'react';

type Direction = 'UP' | 'DOWN' | 'LEFT' | 'RIGHT';

type Props = {
    dir?: Direction;
    className?: string;
};

const DIRECTION: Record<Direction, ComponentType<Featherico>> = {
    UP: IconChevronUp,
    DOWN: IconChevronDown,
    LEFT: IconChevronLeft,
    RIGHT: IconChevronRight,
};

export default function Arrow({ className, dir = 'DOWN' }: Props) {
    const Icon = DIRECTION[dir];
    return <Icon className={className} />;
}
